import ApplicationFieldWrapper, {
  IFieldWrapper as IApplicationFieldWrapper,
} from "entities/Application/components/FieldWrapper";
import { IApplicationField } from "entities/Application/sdk";
import ChecklistFieldWrapper, {
  IFieldWrapper as IChecklistFieldWrapper,
} from "entities/Checklist/components/FieldWrapper";
import { FieldWrapperType } from "entities/Checklist/constants";
import { IPackageDetailsField } from "entities/Checklist/sdk";
import { IPackageField } from "entities/Package/sdk";

type IChecklistFieldWrapperMeta = Omit<IChecklistFieldWrapper, "field">;
type IApplicationFieldWrapperMeta = Omit<
  IApplicationFieldWrapper,
  "field" | "onUpdate"
> & { onUpdate?: () => void };

export type IFieldWrapperMeta =
  | {
      fieldWrapperType: FieldWrapperType.APPLICATION;
      fieldWrapperMeta: IApplicationFieldWrapperMeta;
    }
  | {
      fieldWrapperType: FieldWrapperType.CHECKLIST;
      fieldWrapperMeta: IChecklistFieldWrapperMeta;
    };

export type IApplicationFieldOrIPackageDetailsFieldOrIPackageField =
  | IApplicationField
  | IPackageDetailsField
  | IPackageField;

export type IFieldWrapperManager = {
  field: IApplicationFieldOrIPackageDetailsFieldOrIPackageField;
} & IFieldWrapperMeta;

const FieldWrapperManager = ({
  field,
  fieldWrapperType,
  fieldWrapperMeta,
}: IFieldWrapperManager) => {
  if (fieldWrapperType === FieldWrapperType.APPLICATION) {
    return (
      <ApplicationFieldWrapper
        field={field as IApplicationField}
        editable={fieldWrapperMeta.editable}
        applicationId={fieldWrapperMeta.applicationId}
        onUpdate={fieldWrapperMeta.onUpdate}
      />
    );
  }

  if (fieldWrapperType === FieldWrapperType.CHECKLIST) {
    return <ChecklistFieldWrapper field={field as IPackageDetailsField} />;
  }

  return <></>;
};

export default FieldWrapperManager;
